// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-bundle-screen {
  position: relative;
}
.create-bundle-screen-form {
  padding: 2rem;
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .create-bundle-screen-form {
    padding: 1rem;
  }
}
.create-bundle-screen-example {
  background: var(--white);
  border: 1px solid var(--black2);
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 0.5rem;
}
.create-bundle-screen-example-header {
  padding: 1.25rem;
  border-bottom: 1px solid var(--black2);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.create-bundle-screen-example-header button {
  min-height: 2.25rem;
  padding: 0.5rem 1rem;
  margin-left: 1rem;
}
.create-bundle-screen-example-header-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 0.5rem;
}
.create-bundle-screen-example-item {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--black2);
  display: flex;
}
.create-bundle-screen-example-item:last-child {
  border-bottom: none;
}
.create-bundle-screen-example-item-img {
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  border: 1px solid var(--black2);
  border-radius: 0.5rem;
  background: var(--black0);
}
.create-bundle-screen-example-item-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
  margin-bottom: 0.25rem;
}
.create-bundle-screen-example-item-price {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: var(--black4);
}
.create-bundle-screen-example-item-price i {
  font-style: normal;
  text-decoration-line: line-through;
}
.create-bundle-screen-example-item-price span {
  color: var(--purple6);
  font-weight: 600;
  text-decoration-line: none;
  margin-right: 0.5rem;
}
.create-bundle-screen-one-row {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .create-bundle-screen-one-row {
    flex-direction: column;
  }
}
.create-bundle-screen-one-row > div {
  width: calc(50% - 0.5rem);
}
@media (max-width: 768px) {
  .create-bundle-screen-one-row > div {
    width: 100%;
    margin-right: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/upselling/screens/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,aAAA;EACA,gBAAA;AACJ;AACI;EAJF;IAKI,aAAA;EAEJ;AACF;AAEE;EACE,wBAAA;EACA,+BAAA;EACA,4CAAA;EACA,qBAAA;AAAJ;AAEI;EACE,gBAAA;EACA,sCAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AAAN;AAEM;EACE,mBAAA;EACA,oBAAA;EACA,iBAAA;AAAR;AAGM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AADR;AASI;EACE,qBAAA;EACA,sCAAA;EACA,aAAA;AAPN;AASM;EACE,mBAAA;AAPR;AAUM;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;AARR;AAWM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AATR;AAYM;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAVR;AAYQ;EACE,kBAAA;EACA,kCAAA;AAVV;AAaQ;EACE,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,oBAAA;AAXV;AAiBE;EACE,aAAA;EACA,8BAAA;AAfJ;AAiBI;EAJF;IAKI,sBAAA;EAdJ;AACF;AAgBI;EACE,yBAAA;AAdN;AAgBM;EAHF;IAII,WAAA;IACA,0BAAA;EAbN;AACF","sourcesContent":[".create-bundle-screen {\n  position: relative;\n\n  &-form {\n    padding: 2rem;\n    margin-bottom: 0;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n    }\n\n  }\n\n  &-example {\n    background: var(--white);\n    border: 1px solid var(--black2);\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);\n    border-radius: .5rem;\n\n    &-header {\n      padding: 1.25rem;\n      border-bottom: 1px solid var(--black2);\n      display: flex;\n      align-items: flex-end;\n      justify-content: space-between;\n\n      button {\n        min-height: 2.25rem;\n        padding: .5rem 1rem;\n        margin-left: 1rem;\n      }\n\n      &-title {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--black9);\n        margin-bottom: .5rem;\n\n        & + div {\n\n        }\n      }\n    }\n\n    &-item {\n      padding: 1rem 1.25rem;\n      border-bottom: 1px solid var(--black2);\n      display: flex;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      &-img {\n        width: 2.5rem;\n        height: 2.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: .75rem;\n        border: 1px solid var(--black2);\n        border-radius: 0.5rem;\n        background: var(--black0);\n      }\n\n      &-title {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--black9);\n        margin-bottom: .25rem;\n      }\n\n      &-price {\n        font-family: 'Inter';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 13px;\n        line-height: 16px;\n        color: var(--black4);\n\n        i {\n          font-style: normal;\n          text-decoration-line: line-through;\n        }\n\n        span {\n          color: var(--purple6);\n          font-weight: 600;\n          text-decoration-line: none;\n          margin-right: .5rem;\n        }\n      }\n    }\n  }\n\n  &-one-row {\n    display: flex;\n    justify-content: space-between;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    & > div {\n      width: calc(50% - .5rem);\n\n      @media (max-width: 768px) {\n        width: 100%;\n        margin-right: 0 !important;\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
